import Instructions from './instructions';

export default Instructions;
